import { SidebarInset } from "@/components/ui/sidebar";
import { Badge } from "@/components/ui/badge";
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { TrendingDownIcon, TrendingUpIcon } from "lucide-react";

import TimelinePage from "@/components/Timeline";
import ReservationCalendar from "@/garageManagment/reservations/ReservationCalendar";
import { ChartAreaInteractive } from "@/components/chart-area-interactive";
import { AppBar } from "@/layout";

export const ServiceDashboard = () => {
  return (
    <SidebarInset>
      <AppBar />
      <div className="flex flex-1 flex-col">
        <div className="@container/main flex flex-1 flex-col gap-2">
          <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
            <div
              className="*:data-[slot=card]:shadow-xs px-4 *:data-[slot=card]:bg-gradient-to-t 
                            *:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card dark:*:data-[slot=card]:bg-card lg:px-6 @xl/main:grid-cols-2 @5xl/main:grid-cols-4 grid grid-cols-1 gap-4 "
            >
              <Card className="@container/card">
                <CardHeader className="relative">
                  <CardDescription>Total Revenue</CardDescription>
                  <CardTitle className="@[250px]/card:text-3xl text-2xl font-semibold tabular-nums">
                    $200
                  </CardTitle>
                  <div className="absolute right-4 top-4">
                    <Badge
                      variant="outline"
                      className="flex gap-1 rounded-lg text-xs"
                    >
                      <TrendingUpIcon className="size-3" />
                      +12.5%
                    </Badge>
                  </div>
                </CardHeader>
                <CardFooter className="flex-col items-start gap-1 text-sm">
                  <div className="line-clamp-1 flex gap-2 font-medium">
                    Trending up this month <TrendingUpIcon className="size-4" />
                  </div>
                  <div className="text-muted-foreground">
                    Visitors for the last 6 months
                  </div>
                </CardFooter>
              </Card>
              <Card className="@container/card">
                <CardHeader className="relative">
                  <CardDescription>Total orders</CardDescription>
                  <CardTitle className="@[250px]/card:text-3xl text-2xl font-semibold tabular-nums">
                    8
                  </CardTitle>
                  <div className="absolute right-4 top-4">
                    <Badge
                      variant="outline"
                      className="flex gap-1 rounded-lg text-xs"
                    >
                      <TrendingDownIcon className="size-3" />
                      -20%
                    </Badge>
                  </div>
                </CardHeader>
                <CardFooter className="flex-col items-start gap-1 text-sm">
                  <div className="line-clamp-1 flex gap-2 font-medium">
                    Down 20% this period <TrendingDownIcon className="size-4" />
                  </div>
                  <div className="text-muted-foreground">
                    Acquisition needs attention
                  </div>
                </CardFooter>
              </Card>
              <Card className="@container/card">
                <CardHeader className="relative">
                  <CardDescription>Your inventory</CardDescription>
                  <CardTitle className="@[250px]/card:text-3xl text-2xl font-semibold tabular-nums">
                    7
                  </CardTitle>
                  <div className="absolute right-4 top-4">
                    <Badge
                      variant="outline"
                      className="flex gap-1 rounded-lg text-xs"
                    >
                      <TrendingUpIcon className="size-3" />
                      +12.5%
                    </Badge>
                  </div>
                </CardHeader>
                <CardFooter className="flex-col items-start gap-1 text-sm">
                  <div className="line-clamp-1 flex gap-2 font-medium">
                    Strong user retention <TrendingUpIcon className="size-4" />
                  </div>
                  <div className="text-muted-foreground">
                    Engagement exceed targets
                  </div>
                </CardFooter>
              </Card>
              <Card className="@container/card">
                <CardHeader className="relative">
                  <CardDescription>Clients</CardDescription>
                  <CardTitle className="@[250px]/card:text-3xl text-2xl font-semibold tabular-nums">
                    3
                  </CardTitle>
                  <div className="absolute right-4 top-4">
                    <Badge
                      variant="outline"
                      className="flex gap-1 rounded-lg text-xs"
                    >
                      <TrendingUpIcon className="size-3" />
                      +4.5%
                    </Badge>
                  </div>
                </CardHeader>
                <CardFooter className="flex-col items-start gap-1 text-sm">
                  <div className="line-clamp-1 flex gap-2 font-medium">
                    Steady performance <TrendingUpIcon className="size-4" />
                  </div>
                  <div className="text-muted-foreground">
                    Meets growth projections
                  </div>
                </CardFooter>
              </Card>
            </div>
            <div
              className="*:data-[slot=card]:shadow-xs px-4 *:data-[slot=card]:bg-gradient-to-t 
                            *:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card dark:*:data-[slot=card]:bg-card lg:px-6 grid md:grid-cols-2 gap-5"
            >
              <TimelinePage />
              <ChartAreaInteractive />
            </div>

            <div className="grid place-items-start px-4 lg:px-6 gap-5">
              <div className="max-h-full w-full ">
                <Card className="p-4 max-h-full">
                  <ReservationCalendar />
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SidebarInset>
  );
};

export default ServiceDashboard;
